import React from 'react';

import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text/text';

import Logo from 'shared/components/logo/logo';
import Spinner from 'shared/components/spinner/spinner';
import type { NamedFC } from 'shared/types/named-fc.types';

import type { PaymentStatus as Props } from './payment-status.props';

const PaymentStatus: NamedFC<Props> = ({ errorCode, link, logo, status }) => {
  return (
    <div className="payment-status" data-error-code={errorCode}>
      <Logo {...logo} />
      <div className="payment-status__content">
        <Text elementName="h1">{status}</Text>
        {link ? (
          <LinkButton {...link} />
        ) : (
          <Spinner size={Spinner.sizes.medium} />
        )}
      </div>
    </div>
  );
};

PaymentStatus.displayName = 'PaymentStatus';

export default PaymentStatus;
